import { api } from '../initFetch'

export const getTeamsUserConsent = async (Email, Consent) => {
  const res = await api.post(`/p4m/UserInfo/GetTeamsUserConsent`, {
    Email,
    Consent,
  })
  return res.json
}
